import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  type SelectChangeEvent,
} from '@mui/material';

interface SortOptionsProps {
  sortBy: 'profit_desc' | 'created_desc' | 'updated_desc';
  onChange: (sortBy: 'profit_desc' | 'created_desc' | 'updated_desc') => void;
}

const SortOptions: React.FC<SortOptionsProps> = ({
  sortBy,
  onChange,
}) => {
  const { t } = useTranslation();
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as 'profit_desc' | 'created_desc' | 'updated_desc');
  };

  return (
    <Box>
      <FormControl fullWidth size="small">
        <InputLabel id="sort-options-label">{t('settings.display.sortBy')}</InputLabel>
        <Select
          labelId="sort-options-label"
          id="sort-options"
          value={sortBy}
          label={t('settings.display.sortBy')}
          onChange={handleChange}
        >
          <MenuItem value="profit_desc">{t('settings.display.sortOptions.profitDesc')}</MenuItem>
          <MenuItem value="created_desc">{t('settings.display.sortOptions.createdDesc')}</MenuItem>
          <MenuItem value="updated_desc">{t('settings.display.sortOptions.updatedDesc')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default SortOptions;